import React, { useState } from 'react';
import { Link, useNavigate, useLocation } from 'react-router-dom';
import useAuthStore from '../store/authStore';

export default function Navbar() {
  const { user, logout, isLogado } = useAuthStore();
  const navigate = useNavigate();
  const location = useLocation();
  const [menuOpen, setMenuOpen] = useState(false);

  const handleLogout = () => { logout(); navigate('/'); };

  const dashLink = () => {
    if (user?.tipo === 'admin')     return '/admin';
    if (user?.tipo === 'empresa')   return '/empresa';
    if (user?.tipo === 'candidato') return '/candidato';
    return '/';
  };

  const isActive = (path) => location.pathname.startsWith(path);

  return (
    <nav className="bg-acre-dark sticky top-0 z-50 shadow-lg">
      <div className="max-w-6xl mx-auto px-4 sm:px-6">
        <div className="flex items-center justify-between h-14">

          {/* Logo */}
          <Link to="/" className="flex items-center gap-2">
            <span className="text-2xl">🌿</span>
            <span className="font-sora font-bold text-xl text-white tracking-tight">
              Acre<span className="text-acre-gold">Job</span>
            </span>
          </Link>

          {/* Desktop nav */}
          <div className="hidden md:flex items-center gap-1">
            <Link to="/vagas"
              className={`px-3 py-1.5 rounded-md text-sm font-medium transition-colors
                ${isActive('/vagas') ? 'bg-white/10 text-white' : 'text-white/70 hover:text-white hover:bg-white/10'}`}>
              Ver Vagas
            </Link>

            {isLogado() ? (
              <>
                <Link to={dashLink()}
                  className="px-3 py-1.5 rounded-md text-sm font-medium text-white/70 hover:text-white hover:bg-white/10 transition-colors">
                  Dashboard
                </Link>
                <div className="flex items-center gap-2 ml-2 pl-2 border-l border-white/20">
                  <div className="flex flex-col items-end">
                    <span className="text-white text-xs font-medium leading-none">{user?.nome?.split(' ')[0]}</span>
                    <span className="text-white/50 text-xs capitalize leading-none mt-0.5">{user?.tipo}</span>
                  </div>
                  <button onClick={handleLogout}
                    className="text-xs text-white/60 hover:text-red-300 transition-colors px-2 py-1 rounded">
                    Sair
                  </button>
                </div>
              </>
            ) : (
              <div className="flex items-center gap-2 ml-2">
                <Link to="/login"
                  className="text-sm font-medium text-white/80 hover:text-white px-3 py-1.5 rounded-md hover:bg-white/10 transition-colors">
                  Entrar
                </Link>
                <Link to="/cadastro"
                  className="text-sm font-semibold bg-acre-gold text-acre-dark px-4 py-1.5 rounded-lg hover:bg-yellow-400 transition-colors">
                  Cadastrar
                </Link>
              </div>
            )}
          </div>

          {/* Mobile button */}
          <button className="md:hidden text-white p-1" onClick={() => setMenuOpen(!menuOpen)}>
            <svg className="w-6 h-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              {menuOpen
                ? <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12"/>
                : <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16"/>}
            </svg>
          </button>
        </div>

        {/* Mobile menu */}
        {menuOpen && (
          <div className="md:hidden border-t border-white/10 py-3 space-y-1">
            <Link to="/vagas" className="block px-3 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10 rounded-md" onClick={() => setMenuOpen(false)}>Ver Vagas</Link>
            {isLogado() ? (
              <>
                <Link to={dashLink()} className="block px-3 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10 rounded-md" onClick={() => setMenuOpen(false)}>Dashboard</Link>
                <button onClick={() => { handleLogout(); setMenuOpen(false); }} className="block w-full text-left px-3 py-2 text-sm text-red-300 hover:bg-white/10 rounded-md">Sair</button>
              </>
            ) : (
              <>
                <Link to="/login" className="block px-3 py-2 text-sm text-white/80 hover:text-white hover:bg-white/10 rounded-md" onClick={() => setMenuOpen(false)}>Entrar</Link>
                <Link to="/cadastro" className="block px-3 py-2 text-sm text-acre-gold font-semibold hover:bg-white/10 rounded-md" onClick={() => setMenuOpen(false)}>Cadastrar</Link>
              </>
            )}
          </div>
        )}
      </div>
    </nav>
  );
}
